import { PenetratingArrowsConfig } from 'game/extended/heros/ranger/penetrating_arrows/penetrating_arrows'

export const penetrating_arrows_config: Array<PenetratingArrowsConfig> = [
    {
        splash: 30
    },
    {
        splash: 60
    }
]